import { createFileRoute } from "@tanstack/react-router"
import { ProfileEiTestPage } from "@/pages/profile/ei-test"

export const Route = createFileRoute("/_authenticated/profile/ei-test")({
	component: ProfileEiTestPage,
})
